module.exports = __webpack_public_path__ + "img/bold-checkbox-unchecked.0b139314.svg";